<form action="" #addressForm="ngForm" (ngSubmit)="openModal(template)">
  <div style="display: flex; gap: 10px;">
    <input [(ngModel)]="fullAddress.street" name="street" class="form-control street-row" type="text" placeholder="{{'PropertySearch.Searchfor'|translate}}">
    <button
      type="submit"
      class="btn btn-active search-btn"
      style="text-transform: uppercase; padding: 0px 70px; width: 20%;">
      {{'AidAddress.Search'|translate}}
    </button>
  </div>
</form>

<ng-template #template class="">
  <div class="">
    @if (!loading) {
      <div class="">
        <div class="modal-header d-flex justify-content-between align-items-center">
          <h4 class="modal-title" style="font: inherit; font-weight: bold;">
            {{'AidAddress.Please' | translate}}
          </h4>
          <button type="button" class="close close-btn" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true"><i class="fas fa-times"></i></span>
          </button>
        </div>
        <div  class="modal-body main-panel">
          <table infiniteScroll
            [infiniteScrollDistance]="2"
            [infiniteScrollThrottle]="50"
            [infiniteScrollContainer]="selector"
            [fromRoot]="true"
            (scrolled)="onScroll()" class="table table-striped ">
            <tbody>
              @for (item of addressList; track item) {
                <tr  (click)="this.addressLookUp(item)" class="address-item">
                  <th><strong>AIN: </strong> {{item.AIN}}</th>
                  <th><strong>{{'AidAddress.Address'|translate}}: </strong> {{item.SitusStreet}}, {{item.SitusCity}} {{item.SitusZipCode}}</th>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }
  </div>

  @if (loading) {
    <div style="height: 75vh;"  class="model-body">
      <div class="loading d-flex">
        <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
      </div>
    </div>
  }
</ng-template>
